import {api} from "./api.service";

export class JournalService {
  static async createJournal(data) {
    return api.post(`journal`, data);
  }
  static async getJournal(
    type = "",
    journalId = "",
    exportCsv = false,
    exportExcel = false,
    exportPdf = false,
    createdAt = true,
    sort = "createdAt",
    order = "desc",
    search = ""
  ) {
    const params = {};

    if (type) {
      params["type"] = type;
    }

    if (journalId) {
      params["journalId"] = journalId;
    }

    if (exportCsv) {
      params["exportCsv"] = exportCsv;
    }

    if (exportExcel) {
      params["exportExcel"] = exportExcel;
    }

    if (exportPdf) {
      params["export"] = exportPdf;
    }

    if (createdAt) {
      params["createdAt"] = createdAt;
    }

    if (sort) {
      params["sort"] = "createdAt";
    }
    if (order) {
      params["order"] = "desc";
    }

    if (search) {
      params["search"] = search;
    }

    return api.get(`journal`, { params });
  }
  static async getSingleJournal(id) {
    return api.get(`journal/${id}`);
  }
  static async editJournal(id, data) {
    return api.patch(`journal/${id}`, data);
  }
  static async deleteJournal(id) {
    return api.delete(`journal/${id}`);
  }
}
